module.exports = require("./fa.d.ts");